export default __webpack_public_path__ + "static/media/Coot07.fa03f5f9.jpg";